module.exports = __webpack_public_path__ + "static/fonts/Robotomediumitalic.f5cbcf6.ttf";